import { Button } from "react-bootstrap";

const RalliesHeader = ({ searchTerm, onSearchChange, total, onAddRally }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Rallies ({total})</h4>
      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search rallies"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddRally}>
          + Create Rally
        </Button>
      </div>
    </div>
  );
};

export default RalliesHeader;
